/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  $(function () {
    // 倒计时
    function getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
      let nowTime = new Date()
      let endTime = new Date(endTimeG)

      let leftTime = endTime.getTime() - nowTime.getTime()
      if (leftTime < 0) {
        setupNewCountdown()
        leftTime = 0
      }
      let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
        leftM = Math.floor((leftTime / (1000 * 60)) % 60),
        leftS = Math.floor((leftTime / 1000) % 60)
      leftH = leftH >= 10 ? leftH : '0' + leftH
      leftM = leftM >= 10 ? leftM : '0' + leftM
      leftS = leftS >= 10 ? leftS : '0' + leftS

      return {
        hour: leftH,
        minute: leftM,
        second: leftS,
      }
    }
    function setupNewCountdown() {
      const randomHour = getRandomNum(1, 9)
      const currentTime = new Date()
      endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId

    function getCutDownTime() {
      setupNewCountdown()
      if (intervalId) clearInterval(intervalId)
      intervalId = setInterval(function () {
        let cutDownTimeText = cutDownTime()
        $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
        $('.sp_top_cut_down .sp_left_view .sp_minute').html(
          cutDownTimeText.minute
        )
        $('.sp_top_cut_down .sp_left_view .sp_second').html(
          cutDownTimeText.second
        )
      }, 1000)
    }

    getCutDownTime()

    new Swiper('.sp-swiper1', {
      autoplay: {
        // delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
    })

    let spImgList = [
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-p1.png',
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-p2.png',
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-b1.png',
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-b2.png',
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-b3.png',
      'https://cdn.shopify.com/s/files/1/0717/2712/0602/files/20241210-b4.png',
    ]

    function mainRender() {
      $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)

        window.addEventListener(
          'resize',
          (function () {
            var timer
            return function () {
              if (timer) clearTimeout(timer)
              timer = setTimeout(function () {
                $('#root').css('zoom', 'normal')
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              }, 100)
            }
          })()
        )
      })

      function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
        const config = {
          rootMargin: '0px 0px 1300px 0px',
          threshold: 0,
        }

        const lazyLoadObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 当图片进入视口时
              const image = entry.target
              const dataSrc = image.getAttribute('data-src')
              image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
              lazyLoadObserver.unobserve(image) // 停止观察该图片
            }
          })
        },
        config)

        images.forEach(function (image) {
          lazyLoadObserver.observe(image) // 开始观察每个图片
        })
      }

      function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
          // 处理二维数组
          imageArray.forEach(subArray => {
            subArray.forEach(url => {
              const img = new Image()
              img.src = url
            })
          })
        } else {
          // 处理一维数组
          imageArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        }
      }

      lazyLoadImages()

      preloadImages(spImgList)
      // 字体轮播
      new Swiper('.mySwiperFree', {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        loop: true,
      })

      // 找到所有跳转套餐的锚点链接
      var links = document.querySelectorAll('a[href^="#shopping"]')
      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault() // 阻止默认的跳转行为
          // var targetElement = document.getElementById('shopping');
          // if (targetElement) {
          //     targetElement.scrollIntoView({ behavior: 'smooth' });
          // } // 方式一

          const targetElement = document.getElementById('shopping') // 获取跳转目标节点
          const offsetTop = targetElement.offsetTop

          window.scroll({
            top:
              offsetTop * $('div#root').css('zoom') -
              300 * $('div#root').css('zoom'),
            behavior: 'smooth', // 使用 smooth 实现平滑滚动
          }) // 方式二
        })
      })

      // IOS字体多了间距的处理 给节点添加 sp_system 类名
      // 判断当前用户是安卓端还是iOS端
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      var isAndroid = /android/i.test(userAgent)
      var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
      var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

      if (isAndroid) {
        console.log('Android')
      } else if (isIOS) {
        console.log('iOS')
      } else if (isPC) {
        console.log('PC')
      } else {
        $('.sp_system').css('letter-spacing', '-4px')
      }
    }

    mainRender()

    $('.sp-option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      // $(this);
      // style选项

      let img0 = $('.product-part  .p-img')
      let _index = $(this).index()

      img0[0].srcset = spImgList[_index]
      $(this).closest(".product-box").find(".sp-img-wrap img").eq(_index).show()
      $(this).closest(".product-box").find(".sp-img-wrap img").eq(_index ? 0 : 1).hide()
    })
    $('.sp-btn-style').click(function () {
      let id1 = $(this).siblings('.sp-opts').find('div.active').attr('data-id')
      let id2 = $(this).attr('data-id')
      let id = id1 ? id1 : id2
      window.location.href = '/cart/' + id + ':' + 1
    })
  })
})
